import { get, post } from '../../api-config';
import { gdpService } from './_service';

// Novedades de versión del usuario logado (Inicio → Novedades). Cada nota trae `read` ya resuelto en gdp-api:
// las retrospectivas y las anteriores al alta del usuario vienen como leídas.
export const getReleaseNotes = () => get(gdpService, '/release-notes', null, null);
export const getReleaseNotesUnreadCount = () => get(gdpService, '/release-notes/unread-count', null, null);
export const postReleaseNoteRead = (id: string) => post(gdpService, `/release-notes/${id}/read`, null, null);
export const postReleaseNotesReadAll = () => post(gdpService, '/release-notes/read-all', null, null);
